export default function StatsExport({ onConfirm }) {
  const handleClose = async () => {
    document.querySelector("#close-modal-button").click();
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (onConfirm !== null) await onConfirm(e);
  };

  return (
    <form onSubmit={(e) => handleConfirm(e)}>
      <div className="w-100">
        <label className="d-block mt-2">DA DATA FORMAZIONE</label>
        <input name="from_date" type="date" className="w-100 mb-3" />
        <label className="d-block mt-2">A DATA FORMAZIONE</label>
        <input name="to_date" type="date" className="w-100" />
      </div>
      <div className="d-flex gap-3 w-100 justify-content-end mt-4">
        <button
          className="q8-blue-button py-2 px-4"
          onClick={() => handleClose()}
          type="button"
        >
          ANNULLA
        </button>
        <button className="q8-blue-button py-2 px-4" type="submit">
          ESPORTA
        </button>
      </div>
    </form>
  );
}
